import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  Drawer,
} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getProduct, getThread } from "../redux/selectors";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { summaryService } from "../api";
import HorisontalChart from "./HorizontalChart";
import { findSource } from "../scripts/utils";

const SmiHorizontal: React.FC = () => {
  const thread = useSelector(getThread);
  const product = useSelector(getProduct);
  const feedFilter = useSelector(getFeedFilter);
  const [loading, setLoading] = useState(true);
  const [dataArr, setDataArr] = useState([]);
  const [profilesArr, setProfilesArr] = useState([]);
  const [labelsArr, setLabelsArr] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (thread) {
      let params = {
        thread_id: +thread.id,
        product_id: product,
        from: feedFilter.from.slice(0, 10) + " 00:00:00",
        to: feedFilter.to.slice(0, 10) + " 23:59:59",
        type: "smi",
        limit: 7,
      };
      setLoading(true);
      summaryService
        .loadSourceTop(params)
        .then((resp) => {
          resp.sort((a: any, b: any) => b.post_count - a.post_count);
          setDataArr(resp.map((it: any) => it.post_count));
          setLabelsArr(resp.map((it: any) => findSource(it.title)));
          setProfilesArr(resp.map((it: any) => findSource(it.profile_id)))
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [thread, feedFilter, product]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div className="white-block-small">
      <div className="">
        <p className="block-title">
          По количеству публикаций в СМИ
          <InfoCircleOutlined className="info" onClick={showDrawer} />
        </p>
      </div>
      {loading ? (
        <div className="feed-posts-loader" style={{ height: "300px" }}>
          <LoadingOutlined />
        </div>
      ) : (
        <HorisontalChart labelsArr={labelsArr} dataArr={dataArr} profiles={profilesArr}/>
      )}
      <Drawer title="Что отображает этот график?" onClose={onClose} open={open}>
        <p className="purple-border">
          График иллюстрирует источники СМИ, разместившие наибольшее количество
          публикаций с упоминаниями компании за выбранный период.
        </p>
        <p className="gray-block">
          <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в реальном
          времени, что позволяет вам следить за актуальными трендами и реакцией
          аудитории на ваш контент
        </p>
      </Drawer>
    </div>
  );
};

export default SmiHorizontal;
